import React, { useState } from 'react';
import { ComplaintSummarySection as ComplaintSummarySectionType } from '../../../../../types/case-workspace';
import { parseDecisionReferences } from '../../../../../utils/decisionLinks';
import IconWrapper from '../../../../IconWrapper';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import ReportSectionHeading from './ReportSectionHeading';

interface ComplaintSummarySectionProps {
  summary: ComplaintSummarySectionType;
  verbatim?: string;
  onDecisionClick?: (decisionIdOrReference: string) => void;
}

const ComplaintSummarySection: React.FC<ComplaintSummarySectionProps> = ({ summary, verbatim, onDecisionClick }) => {
  const [isVerbatimExpanded, setIsVerbatimExpanded] = useState(false);
  const segments = parseDecisionReferences(summary.summary);
  const hasVerbatim = verbatim && verbatim.trim().length > 0;

  return (
    <section className="border-b border-border px-6 py-5">
      <ReportSectionHeading number={1} title="Summary" className="mb-4" />
      <div className="space-y-4">
        <p className="text-[13px] leading-[1.7] text-foreground">
        {segments.map((segment, index) => {
          if (segment.isReference && segment.reference && onDecisionClick) {
            return (
              <button
                key={index}
                onClick={() => onDecisionClick(segment.reference!)}
                className="text-primary hover:underline cursor-pointer font-medium"
              >
                {segment.text}
              </button>
            );
          } else if (segment.isReference && segment.reference) {
            return (
              <a
                key={index}
                href={`#precedent-${segment.reference}`}
                className="text-primary hover:underline"
              >
                {segment.text}
              </a>
            );
          }
          return <span key={index}>{segment.text}</span>;
        })}
        </p>
      
        {hasVerbatim && (
          <div className="border-t border-border pt-4">
            <button
              onClick={() => setIsVerbatimExpanded(!isVerbatimExpanded)}
              className="group flex items-center gap-2 text-[12px] font-medium text-primary transition-colors hover:text-primary/80"
            >
              <IconWrapper
                icon={isVerbatimExpanded ? FiChevronUp : FiChevronDown}
                className="h-3.5 w-3.5 transition-transform group-hover:scale-110"
              />
              <span>{isVerbatimExpanded ? 'Hide' : 'Show'} full feedback text</span>
            </button>

            {isVerbatimExpanded && (
              <div className="mt-3 rounded-lg border border-[var(--go-warm-border)] bg-[var(--go-spring)] p-4">
                <p className="whitespace-pre-wrap text-[13px] italic leading-[1.7] text-muted-foreground">
                  {verbatim}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default ComplaintSummarySection;
